// const GoogleMap = {
//   renderer: {
//     render: function ({ count, position }, stats) {
//       // create svg url with fill color
//       const svg = window.btoa(`
// 			<svg fill="#242538" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
// 			  <circle cx="120" cy="120" opacity=".6" r="70" />
// 			  <circle cx="120" cy="120" opacity=".3" r="90" />
// 			  <circle cx="120" cy="120" opacity=".2" r="110" />
// 			</svg>`);
//       // create marker using svg icon
//       return new google.maps.Marker({
//         position,
//         icon: {
//           url: `data:image/svg+xml;base64,${svg}`,
//           scaledSize: new google.maps.Size(50, 50),
//         },
//         label: {
//           text: String(count),
//           color: "#fff",
//           fontSize: "12px",
//         },
//         // adjust zIndex to be above other markers
//         zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
//       });
//     },
//   },

//   createMarker(position, map) {
//     // marker icon
//     var icon = {
//       size: new google.maps.Size(30, 40),
//       path: "M15,40Q30,23.886,30,15.388A15.2,15.2,0,0,0,15,0,15.2,15.2,0,0,0,0,15.388Q0,23.886,15,40Z",
//       fillColor: $(".header").css("background-color"),
//       fillOpacity: 1,
//       anchor: new google.maps.Point(15, 40),
//       strokeWeight: 0,
//       scale: 1,
//     };

//     // Marker options
//     var marker_options = {
//       position,
//       optimized: false,
//       map,
//       icon: icon,
//       animation: google.maps.Animation.DROP,
//     };

//     return new google.maps.Marker(marker_options);
//   },

//   styles: [
//     {
//       featureType: "water",
//       elementType: "geometry",
//       stylers: [{ color: "#e9e9e9" }, { lightness: 17 }],
//     },
//     {
//       featureType: "landscape",
//       elementType: "geometry",
//       stylers: [{ color: "#f5f5f5" }, { lightness: 20 }],
//     },
//     {
//       featureType: "road.highway",
//       elementType: "geometry.fill",
//       stylers: [{ color: "#ffffff" }, { lightness: 17 }],
//     },
//     {
//       featureType: "road.highway",
//       elementType: "geometry.stroke",
//       stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }],
//     },
//     {
//       featureType: "road.arterial",
//       elementType: "geometry",
//       stylers: [{ color: "#ffffff" }, { lightness: 18 }],
//     },
//     {
//       featureType: "road.local",
//       elementType: "geometry",
//       stylers: [{ color: "#ffffff" }, { lightness: 16 }],
//     },
//     {
//       featureType: "poi",
//       elementType: "geometry",
//       stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
//     },
//     {
//       featureType: "poi.park",
//       elementType: "geometry",
//       stylers: [{ color: "#dedede" }, { lightness: 21 }],
//     },
//     {
//       elementType: "labels.text.stroke",
//       stylers: [{ visibility: "on" }, { color: "#ffffff" }, { lightness: 16 }],
//     },
//     {
//       elementType: "labels.text.fill",
//       stylers: [{ saturation: 36 }, { color: "#333333" }, { lightness: 40 }],
//     },
//     { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
//     {
//       featureType: "transit",
//       elementType: "geometry",
//       stylers: [{ color: "#f2f2f2" }, { lightness: 19 }],
//     },
//     {
//       featureType: "administrative",
//       elementType: "geometry.fill",
//       stylers: [{ color: "#fefefe" }, { lightness: 20 }],
//     },
//     {
//       featureType: "administrative",
//       elementType: "geometry.stroke",
//       stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }],
//     },
//   ],
// };

// export default GoogleMap;

const GoogleMap = {
  renderer: {
    render: function ({ count, position }, stats) {
      // create svg url with fill color
      const svg = window.btoa(`
			<svg fill="#242538" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
			  <circle cx="120" cy="120" opacity=".6" r="70" />
			  <circle cx="120" cy="120" opacity=".3" r="90" />
			  <circle cx="120" cy="120" opacity=".2" r="110" />
			</svg>`);
      // create marker using svg icon
      return new google.maps.Marker({
        position,
        icon: {
          url: `data:image/svg+xml;base64,${svg}`,
          scaledSize: new google.maps.Size(50, 50),
        },
        label: {
          text: String(count),
          color: "#fff",
          fontSize: "12px",
        },
        // adjust zIndex to be above other markers
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
      });
    },
  },

  /**
   * Create google map
   */
  create(data, mapEl) {
    const pos = {
      lat: data.lat,
      lng: data.lng,
    };

    const map_options = {
      zoom: data.zoom,
      center: pos,
      disableDefaultUI: true,
      zoomControl: true,
      styles: GoogleMap.styles,
    };

    const map = new google.maps.Map(mapEl[0], map_options);

    map.markers = [];
    //const pins = JSON.parse($("#markers").html());

    // Add marker
    const marker = GoogleMap.addMarker(pos, map);

    map.markers.push(marker);

    const icon = {
      url: window.location.origin + "/themes/base/resources/src/img/fl-pin.svg",
      size: new google.maps.Size(63, 79),
    };
  },

  /**
   * Create map marker
   */
  addMarker(position, map) {
    // marker icon
    const icon = {
      url: window.location.origin + "/themes/base/resources/src/img/fl-pin.svg",
      size: new google.maps.Size(63, 79),
    };

    // Marker options
    const marker_options = {
      position,
      optimized: false,
      map,
      icon,
      animation: google.maps.Animation.DROP,
    };

    return new google.maps.Marker(marker_options);
  },

  createMarker(position, map) {
    // marker icon
    var icon = {
      url: window.location.origin + "/themes/base/resources/src/img/fl-pin.svg",

      anchor: new google.maps.Point(63, 79),
      strokeWeight: 0,
      scale: 1,
    };

    // Marker options
    var marker_options = {
      position,
      optimized: false,
      map,
      icon: icon,
      animation: google.maps.Animation.DROP,
    };

    return new google.maps.Marker(marker_options);
  },

  styles: [
    {
      featureType: "landscape.man_made",
      elementType: "geometry",
      stylers: [
        {
          color: "#f7f1df",
        },
      ],
    },
    {
      featureType: "landscape.natural",
      elementType: "geometry",
      stylers: [
        {
          color: "#d0e3b4",
        },
      ],
    },
    {
      featureType: "landscape.natural.terrain",
      elementType: "geometry",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi.business",
      elementType: "all",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi.medical",
      elementType: "geometry",
      stylers: [
        {
          color: "#fbd3da",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        {
          color: "#bde6ab",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#ffe15f",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#efd151",
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#ffffff",
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "black",
        },
      ],
    },
    {
      featureType: "transit.station.airport",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#cfb2db",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: "#a2daf2",
        },
      ],
    },
  ],
};

export default GoogleMap;
